import React from 'react';
import { theme } from '../../styles';

const Consent = () => {
  return (
    <div>
      <input
        type="checkbox"
        id="consent"
        style={{ accentColor: theme.colors.primary }}
      />{' '}
      <span>
        I hereby state that I consent to the terms outlined in the&nbsp;
        <a href="/terms" target="_blank" rel="noreferrer">
          Privacy &amp; Terms
        </a>
        .
      </span>
    </div>
  );
};

export default Consent;
